import useSWR, { SWRConfiguration, SWRResponse } from "swr";
import { UserInvoice } from "../types";

export const useInvoice = (
    invoiceId: number,
    options?: SWRConfiguration
): { invoice: UserInvoice } & SWRResponse<{ data: UserInvoice | null }> => {
    const data = useSWR(invoiceId ? `invoice/${invoiceId}` : null, null, options);
    const invoice = data.data?.data;
    return { ...data, invoice };
};
